import { LitElement, html, css } from 'lit';

class QrCodeDialog extends LitElement {
  static properties = {
    qrCode: { type: String },
    onConfirm: { type: Function },
    onCancel: { type: Function }
  };

  constructor() {
    super();
    this.qrCode = '';
  }

  static styles = css`
    .qr-code-dialog {
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 20px;
      min-width: 300px;
    }

    .dialog-header {
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: var(--text-primary-color);
      margin-bottom: 10px;
    }

    .input-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .input-label {
      font-size: 14px;
      font-weight: 500;
      color: var(--text-primary-color);
    }

    .qr-input {
      padding: 12px 16px;
      border: 2px solid;
      border-radius: 8px;
      font-size: 14px;
      background: var(--bg-primary-color);
      color: var(--text-primary-color);
      outline: none;
      transition: border-color 0.2s ease;
    }

    .qr-input:focus {
      border-color: var(--text-accent);
      box-shadow: 0 0 0 2px rgba(109, 62, 193, 0.1);
    }

    .qr-input::placeholder {
      color: var(--text-secondary);
    }

    .button-container {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
      margin-top: 10px;
    }

    .cancel-btn {
      padding: 10px 20px;
      border: 1px solid var(--border-color);
      background: var(--bg-primary-color);
      color: var(--text-primary-color);
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .cancel-btn:hover {
      background: var(--bg-secondary-color);
    }

    .submit-btn {
      padding: 10px 20px;
      border: none;
      background: #241172;
      color: white;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background 0.2s ease;
    }


    .submit-btn:disabled {
      background: #a78bfa;
      cursor: not-allowed;
    }
  `;

  handleInputChange(e) {
    this.qrCode = e.target.value;
  }

  handleSubmit() {
    if (this.qrCode.trim()) {
      this.onConfirm(this.qrCode);
    }
  }

  handleCancel() {
    this.onCancel();
  }

  render() {
    return html`
      <div class="qr-code-dialog">
        <div class="dialog-header">
          Enter QR Code
        </div>
        
        <div class="input-container">
          <input
            type="text"
            class="qr-input"
            placeholder="Enter Code here"
            .value=${this.qrCode}
            @input=${this.handleInputChange}
            @keyup=${(e) => {
              if (e.key === 'Enter') {
                this.handleSubmit();
              }
            }}
          />
        </div>
        
        <div class="button-container">
          <button class="cancel-btn" @click=${this.handleCancel}>
            Cancel
          </button>
          <button 
            class="submit-btn" 
            @click=${this.handleSubmit}
            ?disabled=${!this.qrCode.trim()}
          >
            Submit
          </button>
        </div>
      </div>
    `;
  }
}

customElements.define('qr-code-dialog', QrCodeDialog); 